import { render, staticRenderFns } from "./Stockists.vue?vue&type=template&id=b62460ac&"
import script from "./Stockists.vue?vue&type=script&lang=js&"
export * from "./Stockists.vue?vue&type=script&lang=js&"
import style0 from "./Stockists.vue?vue&type=style&index=0&id=b62460ac&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports